import { RectRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasLottiePicker, CanvasPickerContribution } from "../constants";

import { DefaultCanvasLottiePicker } from "./lottie-picker";

let loadLottiePick = !1;

export function bindLottieCanvasPickerContribution(container) {
    loadLottiePick || (loadLottiePick = !0, container.bind(CanvasLottiePicker).toDynamicValue((() => new DefaultCanvasLottiePicker(resolveContainerBinding(container, RectRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasLottiePicker));
}
//# sourceMappingURL=lottie-module.js.map
